import React, {useMemo, useState} from "react";
import {useUser} from "./useUser";
import CardDropdown from "../components/common/CardDropdown";
import DropdownItem from "react-bootstrap/DropdownItem";
import {useDataModals} from "./useDataModals";

export const useTableModals = (columns, editPermission, deletePermission) => {
    const {selected, newModal, editModal, deleteModal} = useDataModals();
    const {hasPermission} = useUser();
    const cols = useMemo(() => {
        const canEdit = hasPermission(editPermission);
        const canDelete = hasPermission(deletePermission);
        const col = {
            accessor: 'none',
            Headers: '',
            disableSortBy: true,
            cellProps: {
                className: 'text-end'
            }
        }
        if(canEdit && canDelete) {
            return columns.concat([{
                ...col,
                Cell: (rowData) => {
                    return <CardDropdown>
                        <DropdownItem as={"button"} onClick={() => {editModal.onClick(rowData.row.original)}}>Edit</DropdownItem>
                        <DropdownItem as={"button"} onClick={() => {deleteModal.onClick(rowData.row.original)}}>Delete</DropdownItem>
                    </CardDropdown>
                }
            }])
        }
        if(canEdit) {
            return columns.concat([{
                ...col,
                Cell: (rowData) => {
                    return <CardDropdown>
                        <DropdownItem as={"button"} onClick={() => {editModal.onClick(rowData.row.original)}}>Edit</DropdownItem>
                    </CardDropdown>
                }
            }])
        }
        if(canDelete) {
            return columns.concat([{
                ...col,
                Cell: (rowData) => {
                    return <CardDropdown>
                        <DropdownItem as={"button"} onClick={() => {deleteModal.onClick(rowData.row.original)}}>Delete</DropdownItem>
                    </CardDropdown>
                }
            }])
        }
        return columns;
    },[hasPermission, editPermission, deletePermission, columns])
    
    return {selected, columns: cols, newModal, editModal, deleteModal}
}